
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, { useRef } from "react";
import { getResourceCollection } from "next-drupal";
import Layout from "components/Layout";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import { getGlobals } from "lib/getGlobals";
import Meta from "components/Meta";
import useTranslation from "next-translate/useTranslation";
import Header from "components/Header";
import Image from "next/image";
import formatFileSize from "lib/formatFileSize";
import Button from "components/Button";

export default function LetterIndexPage({ nodes, globals }) {
  const { t } = useTranslation("common");
  const ref = useRef(null);

  const crumbs = [
    {
      path: "home.path",
      title: "home.title",
      translate: true,
    },
    {
      title: "letter.title",
      translate: true,
    },
  ];

  return (
    <Layout
      globals={globals}
      header={<Header crumbs={crumbs} title={t("letter.title")} />}
    >
      <Meta title={t("letter.title")} description={t("letter.description")} />
      <section className="relative pt-16 pb-24">
        <div ref={ref} className="container mx-auto px-4 transition-all">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {nodes.map((node) => {
              const extension = node.field_file.filename.split(".").pop();
              const filesize = formatFileSize(node.field_file.filesize);

              return (
                <div
                  key={node.id}
                  className="flex flex-col bg-secondary-light text-white overflow-hidden"
                >
                  <div className="flex-1 order-1 p-8 xl:p-12">
                    <div className="text-xl font-medium mb-2">{node.title}</div>

                    <div className="flex items-center gap-2 uppercase text-sm font-important font-medium tracking-wider mb-8">
                      <span>{extension}</span>
                      <span> / </span>
                      <span>{filesize}</span>
                    </div>

                    <div>
                      <Button
                        as="a"
                        href={`${process.env.NEXT_PUBLIC_DRUPAL_RUNTIME_BASE_URL}${node.field_file.uri.url}`}
                      >
                        <span>{t("utils.files.download")}</span>
                      </Button>
                    </div>
                  </div>

                  <div className="order-0 relative w-full bg-white">
                    <figure className="aspect-w-16 aspect-h-10">
                      <div>
                        <Image
                          src={node.field_image.image_style_uri.medium_a4}
                          {...node.field_image.resourceIdObjMeta}
                          layout="fill"
                          objectFit="contain"
                        />
                      </div>
                    </figure>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}

 async function _getStaticProps(context) {
  const localeContext = {
    locale: context.locale,
    defaultLocale: context.defaultLocale,
  };

  const params = new DrupalJsonApiParams();

  params.addInclude(["field_image, field_file"]).addFilter("status", 1);

  const nodes = await getResourceCollection("node--letter", {
    params: params.getQueryObject(),
    ...localeContext,
  });

  return {
    props: {
      globals: await getGlobals(context),
      nodes,
    },
    revalidate: 30,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/node--letter/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  